import { EventKind, Notification } from "@nova/schemas"
import { buildCopy, CopyRegistry } from "./copy-registry"
import { isMentionNotification } from "./mentions"
import { NotificationContext } from "./variables"

export type PushNotificationCopy = {
    title: string
    body: string
}

// TODO: draft copy, revise with product/design @zach @jarren
const pushCopyRegistry: CopyRegistry<PushNotificationCopy> = {
    [EventKind.LayerProcessed]: (text, { data }) => ({
        title: text.projectName,
        body:
            data.layerType === "liveVideoFlights"
                ? `${text.layerTypeLabel} ready to replay & export`
                : `${text.layerTypeLabel} finished processing`,
    }),
    [EventKind.LayerProcessingFailed]: (text) => ({
        title: text.projectName,
        body: `${text.layerTypeLabel} failed to process`,
    }),
    [EventKind.StreamStarted]: (text) => ({
        title: text.actorName,
        body: `started a live stream in ${text.projectName}`,
    }),
    [EventKind.LocationSharingStarted]: (text) => ({
        title: text.actorName,
        body: `started sharing their location in ${text.projectName}`,
    }),
    [EventKind.LocationSharingEnded]: (text) => ({
        title: text.actorName,
        body: `stopped sharing their location in ${text.projectName}`,
    }),
    [EventKind.StreamShared]: (text) => ({
        title: text.actorName,
        body: `shared a live stream with you in ${text.projectName}`,
    }),
    [EventKind.MissionGroupStreamShared]: (text) => ({
        title: text.actorName,
        body: "shared a live stream with you",
    }),
    [EventKind.MissionGroupDashboardShared]: (text) => ({
        title: text.actorName,
        body: "shared a mission group dashboard with you",
    }),
    [EventKind.AccessRequested]: (text) => ({
        title: text.actorName,
        body: `has requested access to ${text.accessResourceName}`,
    }),
    [EventKind.AccessGranted]: (text) => ({
        title: `${text.entityType} Access Approved`.trim(),
        body: `You can now ${text.permissionLabel} ${text.accessResourceName}`,
    }),
    [EventKind.CommentCreated]: (text, notification) => ({
        title: text.actorName,
        body: isMentionNotification(notification)
            ? `mentioned you: ${text.commentSnippet}`
            : `replied: ${text.commentSnippet}`,
    }),
}

export const buildPushCopy = (notification: Notification, context: NotificationContext) =>
    buildCopy(pushCopyRegistry, notification, context)
